import { useQuery } from "@apollo/client";
import { isEmpty } from "lodash";
import { getSearchObjectives } from "src/queries/objectives.graphql";

/**
 * Hook to fetch objectives on initial render
 * Can be used for root level or specific objectives
 * @param {Object} options - Query options
 * @param {Array<string>} options.objectiveIds - Array of objective IDs to fetch
 * @param {Object} options.inputOverrides - Override default input values
 * @param {Function} options.onCompleted - Callback function when data loads successfully
 * @returns {Object} Query result with data, loading, error
 */
const useGetObjectives = ({
  objectiveIds = [],
  inputOverrides = {},
  onCompleted,
} = {}) => {
  const isRootLoad = isEmpty(objectiveIds);

  const queryResult = useQuery(getSearchObjectives, {
    variables: {
      input: {
        filter: {
          objectiveIds,
          onlyTopLevelObjectives: isRootLoad,
        },
        excludeBaseObjectives: false,
        includeChildObjectives: false,
        includeParentObjectives: false,
        ...inputOverrides,
      },
    },
    onCompleted: (data) => {
      if (onCompleted) {
        onCompleted(data, { isRootLoad });
      }
    },
  });

  return queryResult;
};

export default useGetObjectives;
